import { useEffect, useState } from 'react';
import { fetchSchedule } from '../utils/scheduleUtils.jsx';
import { resolvePhase } from '../components/landing/phase.js';

// How close the wedding is, resolved once for the whole app. The home page
// and the game both key off it, so it's fetched here rather than in each —
// one request, and no chance of two screens disagreeing about what day it is.
export function useWeddingPhase() {
  const [events, setEvents] = useState(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    let cancelled = false;
    fetchSchedule().then((schedule) => {
      if (!cancelled) setEvents(schedule);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  // Keeps the phase honest without a reload if someone leaves the page open
  // through an event starting or ending.
  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(interval);
  }, []);

  return { phase: resolvePhase(), events, now };
}
